import { useNavigate } from 'react-router-dom';

const features = [
  {
    icon: 'ri-user-add-line',
    title: 'Ücretsiz Kayıt',
    desc: 'Terapistler için platforma kayıt tamamen ücretsizdir.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Telefon Doğrulama',
    desc: 'Telefon numaranız ile güvenli doğrulama yapılır.',
  },
  {
    icon: 'ri-admin-line',
    title: 'Admin Onayı',
    desc: 'Her profil admin tarafından incelenir ve onaylanır.',
  },
  {
    icon: 'ri-eye-off-line',
    title: 'Maskeli Profil',
    desc: 'Tam isim ve fotoğraf gizlenir, sadece baş harfler görünür.',
  },
  {
    icon: 'ri-map-pin-line',
    title: 'Şehir ve Uzmanlık Eşleşme',
    desc: 'Konum ve uzmanlık alanınıza göre en uygun fırsatlar sunulur.',
  },
  {
    icon: 'ri-lock-unlock-line',
    title: 'Çift Taraflı Bilgi Paylaşımı',
    desc: 'İletişim bilgileri sadece iki taraf da onay verdiğinde açılır.',
  },
  {
    icon: 'ri-message-3-line',
    title: 'Güvenli Yazılı Chat',
    desc: 'Platform içinde güvenli ve kayıtlı yazılı iletişim.',
  },
  {
    icon: 'ri-flag-line',
    title: 'Şikayet ve Destek',
    desc: 'Etik dışı davranışlara karşı şikayet sistemi ve admin desteği.',
  },
];

export default function ForTherapistsSection() {
  const navigate = useNavigate();

  return (
    <section id="terapistler-icin" className="w-full bg-white py-14 md:py-20 lg:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
            {/* Left: Heading + CTA */}
            <div className="lg:sticky lg:top-24">
              <span className="inline-block px-3 py-1 bg-dark-teal-50 text-dark-teal-500 text-xs font-semibold rounded-full mb-4">
                Terapistler İçin
              </span>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-deep-navy-500 leading-tight mb-4">
                Yeni fırsatlara gizliliğinizi koruyarak{' '}
                <span className="text-dark-teal-500">ulaşın</span>
              </h2>
              <p className="text-sm md:text-base text-gray-500 leading-relaxed mb-6">
                Profiliniz yalnızca uyumlu spa işletmelerine kontrollü şekilde gösterilir. Herkese açık kariyer sitelerinin aksine, gizliliğiniz ön plandadır.
              </p>
              <button
                onClick={() => navigate('/terapist-kayit')}
                className="px-6 py-3 rounded-full text-sm font-semibold text-white bg-dark-teal-500 hover:bg-dark-teal-600 transition-colors shadow-soft cursor-pointer whitespace-nowrap"
              >
                Terapist Olarak Kayıt Ol
              </button>
            </div>

            {/* Right: Feature Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {features.map((f) => (
                <div
                  key={f.title}
                  className="group p-4 md:p-5 bg-off-white rounded-xl border border-gray-100 hover:border-dark-teal-200 hover:shadow-soft transition-all duration-300"
                >
                  <div className="w-9 h-9 rounded-lg bg-dark-teal-50 flex items-center justify-center mb-3 group-hover:bg-dark-teal-500 transition-colors duration-300">
                    <i className={`${f.icon} text-dark-teal-500 text-base group-hover:text-white transition-colors duration-300`} />
                  </div>
                  <h3 className="text-sm font-semibold text-deep-navy-500 mb-1">{f.title}</h3>
                  <p className="text-xs text-gray-500 leading-relaxed">{f.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Silent Career Mode Special Card */}
          <div className="mt-10 md:mt-14">
            <div className="relative bg-deep-navy-500 rounded-2xl p-6 md:p-8 lg:p-10 overflow-hidden">
              {/* Decorative circles */}
              <div className="absolute top-0 right-0 w-64 h-64 bg-dark-teal-500/10 rounded-full -translate-y-1/2 translate-x-1/3" />
              <div className="absolute bottom-0 left-0 w-48 h-48 bg-soft-gold-500/10 rounded-full translate-y-1/3 -translate-x-1/4" />

              <div className="relative flex flex-col lg:flex-row items-start lg:items-center gap-6 lg:gap-10">
                <div className="w-14 h-14 rounded-2xl bg-soft-gold-500/20 flex items-center justify-center shrink-0">
                  <i className="ri-eye-off-line text-soft-gold-400 text-2xl" />
                </div>
                <div className="flex-1">
                  <h3 className="text-lg md:text-xl font-bold text-white mb-2">Sessiz Kariyer Modu</h3>
                  <p className="text-sm text-gray-300 leading-relaxed max-w-2xl">
                    Yeni fırsatlara açık olun ama herkes tarafından görünmeyin. Profiliniz yalnızca yüksek uyumlu spa işletmelerine kontrollü şekilde gösterilir. Mevcut iş yerinizdeyken bile güvenle fırsatları değerlendirin.
                  </p>
                </div>
                <div className="shrink-0 px-4 py-2 bg-soft-gold-500/20 rounded-full border border-soft-gold-500/30">
                  <span className="text-xs font-semibold text-soft-gold-400">Terapistlere Özel</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}